var VolumeTypes;
(function (VolumeTypes) {
    VolumeTypes[VolumeTypes["voice_call"] = 0] = "voice_call";
    VolumeTypes[VolumeTypes["system"] = 1] = "system";
    VolumeTypes[VolumeTypes["ring"] = 2] = "ring";
    VolumeTypes[VolumeTypes["default"] = 3] = "default";
    VolumeTypes[VolumeTypes["music"] = 3] = "music";
    VolumeTypes[VolumeTypes["alarm"] = 4] = "alarm";
    VolumeTypes[VolumeTypes["notification"] = 5] = "notification";
    VolumeTypes[VolumeTypes["dtmf"] = 8] = "dtmf";
})(VolumeTypes || (VolumeTypes = {}));
export {};
//# sourceMappingURL=definitions.js.map